import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export interface Incident {
    id: string;
    website_id: string;
    status: 'ongoing' | 'resolved';
    error_message: string | null;
    started_at: string;
    resolved_at: string | null;
    duration_seconds: number | null;
    created_at: string;
}

export function useIncidents(websiteId?: string, limit = 50) {
    return useQuery({
        queryKey: ["incidents", websiteId, limit],
        queryFn: async () => {
            return api.getIncidents(websiteId, limit);
        },
        refetchInterval: 60000,
    });
}

export function useOngoingIncidents() {
    return useQuery({
        queryKey: ["incidents", "ongoing"],
        queryFn: async () => {
            return api.getOngoingIncidents();
        },
        refetchInterval: 30000,
    });
}
